import styled from 'styled-components';
// Import Modal directly: the components/common barrel pulls in tenant components and creates a cycle.
import { Modal } from '../../../../components/common/modals/antd-modals';

export const DiscountModal = styled(Modal)`
  /* Extra top padding gives the close icon its own strip so it never overlaps the banner. */
  &.ant-modal .ant-modal-body {
    padding: 56px 24px 24px;
  }
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
  cursor: pointer;
`;
